<template>
  <div class="step-horizontal-navigation">
    <b-button-group class="step-horizontal-navigation__header-buttons">
      <b-button
        v-for="(header, index) in steps"
        :key="index"
        :variant="headerStepVariant(index)"
        :class="headerStepClass(index)"
        class="s-btn-no-custom"
        :disabled="!canGoToStepByHeader(index)"
        @click="goToStep(index)"
      >
        <i
          aria-hidden="true"
          :class="header.icon"
        />
        <span
          class="step-horizontal-navigation__header-buttons-label"
          :class="stepClass(index)"
        >
          {{ getHeaderLabel(header) }}
        </span>
      </b-button>
    </b-button-group>
    <div class="step-horizontal-navigation__header-labels">
      <b-button
        v-for="(header, index) in steps"
        :key="index"
        variant="link"
        :class="stepClass(index)"
        :disabled="!canGoToStepByHeader(index)"
        @click="goToStep(index)"
      >
        {{ getHeaderLabel(header) }}
      </b-button>
    </div>
  </div>
</template>
<style lang="sass" scoped>
  @import src/styles/defaults/variables
  @import "src/styles/defaults/mobile-first"

  .step-horizontal-navigation
    background-color: var(--color-background-dark)
    padding: 7px 15px
    border-top-left-radius: 5px
    border-top-right-radius: 5px
    &__header-buttons
      display: flex
      flex-wrap: wrap
      > *
        flex: 1
        font-size: 1.5em
        &.future-step
          color: $color-gray-medium-dark
        &:not(.future-step)
          opacity: 1
    &__header-buttons-label
      display: block
      font-size: 1rem
      &.active-step,
      &.visited-step
        font-weight: bold
        opacity: 1
      &:not(.active-step),
      &:not(.visited-step)
        opacity: .65
    &__header-labels
      display: none
    +media-min-sm()
      &__header-buttons-label
        display: none
      &__header-labels
        display: flex
        > *
          flex: 1
          text-decoration: none
          color: var(--font-color-primary)
          &.active-step,
          &.visited-step
            color: $color-secondary
            font-weight: bold
            opacity: 1
          &:not(.active-step),
          &:not(.visited-step)
            opacity: .65
</style>
<script>
import NavigationMixin from '../mixins/navigationMixin';
import HeaderNavigationMixin from '../mixins/headerNavigationMixin';

export default {
  name: 'HorizontalNavigation',
  mixins: [NavigationMixin, HeaderNavigationMixin],
};
</script>
